import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactScrollableList from 'react-scrollable-list';
import { history } from '../../../index';
import { authOperations } from "../../../redux/auth";
import { configOperations } from "../../../redux/config";
import { incidentsOperations } from "../../../redux/incidentList";
import { filterOperations } from '../../../redux/filter';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import Button from '@mui/material/Button';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import SortIcon from 'material-ui/svg-icons/content/sort';
import ShareIcon from 'material-ui/svg-icons/social/share';
import ArrowLeft from 'material-ui/svg-icons/navigation/chevron-left';
import CircularProgress from 'material-ui/CircularProgress';
import CertifyDialog from '../../incidentDetails/CertifyDialog';
import StateUploadDialog from '../../uploads/StateUploadDialog';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import FileSaver from 'file-saver';
import AssessmentIcon from '@mui/icons-material/Assessment';
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';
import VerifiedIcon from '@mui/icons-material/Verified';
import Stack from '@mui/material/Stack';
import BulkEditDialog from '../../bulkEdit/BulkEditDialog';

import theme from '../../../muiTheme';
import * as esriLoader from 'esri-loader';
import { isIncidentComplete, isIncidentCertified, formatIdentifierForApi } from '../../../utils/incidentHelper';

import {
  setOriginSelectionGraphics, clearOriginSelectionGraphics,
  refreshOriginLayer, getMapExtent, getOriginLayerDefinitionExpression, getMapScreenshot, getForIdsForQuery
} from '../../esri/mapHub';

import originFields from '../../../defaults/PointOfOriginFields.json'
import IncidentListItem from './IncidentListItem';
import ShareDialog from './ShareDialog';
import './IncidentList.css';

const collapseBtnIconStyle = {padding: "5px", height: "36px", width: "36px"};
const snackBtnIconStyle = {color: "white"};

class IncidentList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      computedListHeight: 200,
      showShareDialog: false,
      showBulkUploadDialog: false,
      showCertifyAgreement: false,
      showDownloadWarning: false,
      sortedIncidents: [],
      isDownloading: false,
      showBulkEditDialog: false
    }
  }

  componentDidMount() {
    if (!window.incidentListResizer) {
      window.incidentListResizer = window.addEventListener("resize", this.updateListHeight);
    }
    this.updateListHeight();
  }

  handleWarningClose = () =>
  {
    this.setState({
      showDownloadWarning: false
    });
  }

  bulkCertifyIncidents = () =>
  {
    this.setState({
      showCertifyAgreement: true
    });
  }

    onCancelStateUpload = () =>
    {
      this.setState({
        showBulkUploadDialog: false
      });
    }

    onCertifyIncidentCancel = () =>
    {
      this.setState({
        showCertifyAgreement: false
      });
    }

  updateListHeight = () => {
    const computedListHeight = document.getElementsByClassName('incident-list')[0] && document.getElementsByClassName('incident-list')[0].clientHeight;
    this.setState({ computedListHeight })
  }

  incidentClicked = (incident, openInQuarantine) =>
  {
    if (!this.props.auth.isCertifier || this.props.auth.isReadOnly)
    {
      openInQuarantine = 0;
    }
    this.props.onIncidentSelected(incident, openInQuarantine);
  }

  incidentChecked = (incident) => {
    if (this.isSelected(incident)) {
      this.props.removeSelectedIncident(incident);
      this.props.removeUniqueFireIdentifier(incident.attributes[originFields.forId]);
      clearOriginSelectionGraphics({
        clearExisting: false,
        graphics: [incident]
      })

    } else {
      this.props.addSelectedIncident(incident);
      this.props.addUniqueFireIdentifier(incident.attributes[originFields.forId])
      setOriginSelectionGraphics({
        clearExisting: false,
        graphics: [incident]
      });
    }
  }

  handleOnMouseOverIncident = (incident) => {
    if(!this.isSelected(incident)){
      setOriginSelectionGraphics({
        clearExisting: this.props.incidentList.selectedIncidents.length === 0,
        graphics: [incident]
      });
    }
  }

  handleOnMouseOutIncident = (incident) => {
    if(!this.isSelected(incident)){
      clearOriginSelectionGraphics({
        clearExisting: this.props.incidentList.selectedIncidents.length === 0,
        graphics: [incident]
      })
    }
  }

  sortChange = (event, index, sortField) => {
    this.props.onSortChange(sortField);
  }

  sortDescChange = () => {
    this.props.onToggleSortDesc()
  }

  isSelected(incident) {
    return (this.props.incidentList.selectedIncidents.filter(item => {
      return item.attributes[originFields.forId] === incident.attributes[originFields.forId]
    }).length > 0)
  }

  clearSelectedIncidents = () => {
    this.props.incidentList.selectedIncidents.map(selectedIncident => {
      this.incidentChecked(selectedIncident);
      return selectedIncident
    })
  }

  handleDownloadCSV = () => {
      esriLoader.loadModules(['esri/geometry/support/webMercatorUtils'])
      .then( ([WebMercatorUtils]) =>
      {
        this.setState({
          isDownloading: true
        });

      getMapExtent().then( extent => {
        getOriginLayerDefinitionExpression().then( definitionExpression =>
          {
              var geographicExtent = WebMercatorUtils.webMercatorToGeographic(extent);
              var filterGeometry = (this.props.filter.geometry) ? this.props.filter.geometry : extent;  
              getForIdsForQuery(this.props.filter.spatialFilterID, filterGeometry, 0, [], definitionExpression).then(forids => {

              window.api.downloadIncidentData(geographicExtent, definitionExpression, forids).then(
                response =>
                {
                 
                  const now = Date.now();
                  const blob = new Blob([response], {type: "text/csv;charset=utf-8"});
                  const queryBlob = new Blob(
                    [`Query: ${definitionExpression} \r\nSpatial Extent: ${JSON.stringify(geographicExtent)}`],
                    { type: "text/plain" }
                  );
                  FileSaver.saveAs(blob, "Incidents_" + now + ".csv");
                  FileSaver.saveAs(queryBlob, "Query_" + now + ".txt");

                  this.setState({
                    isDownloading: false
                  });

                });
            });   
          }
        )
      })
    });
  }

  handleSummariesReporting = () =>
  {
    getMapScreenshot().then( screenshot => {
      getMapExtent().then( extent => {
        getOriginLayerDefinitionExpression().then( definitionExpression => {
          history.push({
            pathname: '/reporting',
            state:
            {
              definitionExpression: definitionExpression,
              extent: extent,
              screenshot: screenshot
            }
          });

        })
      })
    })
  }

  handleBulkEdit = () => {
    //
    this.setState({
      showBulkEditDialog: true
    });
  }

  hideBulkEditDialog = () => {
    //
    this.setState({
      showBulkEditDialog: false
    });
  }

  handleUploadCSV = () => {
    this.setState({
      showBulkUploadDialog: true
    });
  }

  onBulkCertifyAgreed = () =>
  {
    this.setState({
      showCertifyAgreement: false
    });

    if(this.props.incidentList && this.props.incidentList.selectedIncidents){
      const featuresToCertify = this.props.incidentList.selectedIncidents
      .filter(item => {return isIncidentComplete(item);})
      .map(incident => {
        let data = {};
        data[originFields.certifiedField] = originFields.certifiedCodedValue;
        data[originFields.irwinId] = formatIdentifierForApi(incident.attributes[originFields.forId]);

        return {attributes: data};
     });
     if(featuresToCertify && featuresToCertify.length > 0) {
       window.api.saveOccurenceRecords(featuresToCertify).then(
         results => {
           this.props.clearSelectedIncidents();
           if(results.every(result =>{return result.success})){

             refreshOriginLayer();

           }
           else {
             //TODO: Notify User 1 or more failed...
           }
         },
         error => {
           console.log('edit error', error);
           //TODO:  Notify User
         }
     );
     }
    }
  }

  getIsCertifyDisabled = () => {

    if (!this.props.auth.isCertifier) {
      return true;
    }

    let disableCertify = false;

    if (!this.props.incidentList || !this.props.incidentList.selectedIncidents || this.props.incidentList.selectedIncidents.length === 0) 
    {
      return true;
    } 

    if (this.props.incidentList.selectedIncidents.length > 1)   //Don't allow Certify All anymore...
    {
      return true;
    } 

    disableCertify = !this.props.incidentList.selectedIncidents.every(selectedIncident => {
      return isIncidentComplete(selectedIncident) && !isIncidentCertified(selectedIncident) && (!selectedIncident.attributes[originFields.isQuarantined]);
    });

    return disableCertify;
  }

  showShareDialog = () => {
    this.setState({showShareDialog: true});
  }

  hideShareDialog = () => {
    this.setState({showShareDialog: false});
  }

  componentDidUpdate(prevProps) 
  {
    if (this.props.incidentList.incidents !== prevProps.incidentList.incidents || this.props.sortDesc !== prevProps.sortDesc || this.props.sortField !== prevProps.sortField || this.state.sortedIncidents === null ) 
    {
      const incidentsChanged = (this.props.incidentList.incidents !== prevProps.incidentList.incidents);
      const descChanged = (this.props.sortDesc !== prevProps.sortDesc );
      const fieldChanged = ( this.props.sortField !== prevProps.sortField);
      const sortIncidentWereNull = (this.state.sortedIncidents === null );

      this.sortIncidents(incidentsChanged, descChanged, fieldChanged, sortIncidentWereNull);
    }
  }

  sortIncidents = (incidentsChanged, descChanged, fieldChanged, sortIncidentWereNull) => 
  {

    const sortDesc = this.props.sortDesc;
    let sortField = this.props.sortField;

    //Fix for DailyAcres
    if (sortField === "DailyAcres")
    {
      sortField = "IncidentSize";
    }

    let incidents = [];

   if(this.props.incidentList.incidents.length > 0)
   {
     incidents = this.props.incidentList.incidents.sort((a, b) => {

      switch (sortField)
      {
        case "SelectedIncidents":
          const aField = this.isSelected(a);
          const bField = this.isSelected(b);

          if (aField && !bField)
          {
            return (sortDesc ? 1 : -1)
          }

          if (!aField && bField)
          {
            return (sortDesc ? -1 : 1)
          }

          if (!aField && !bField)
          {
            return (sortDesc ? 1 : -1)
          }

          if (aField && bField)
          {
            return (sortDesc ? -1 : 1)
          }
          break;
        case "MinUniqueness":
          const aUnqField = (a.attributes[sortField] !== null) ? a.attributes[sortField] : 1;
          const bUnqField = (b.attributes[sortField] !== null) ? b.attributes[sortField] : 1;

           if (aUnqField < bUnqField)
           {
             return (sortDesc ? 1 : -1)
           }

           if (aUnqField > bUnqField)
           {
             return (sortDesc ? -1 : 1)
           }

           if (aUnqField === bUnqField) 
           {
              return a.attributes["IncidentName"].localeCompare(b.attributes["IncidentName"]);
           }
          break;


        default:
          try
          {
              const aDefField = (isNaN(a.attributes[sortField])) ? a.attributes[sortField].toUpperCase().trim() : a.attributes[sortField];
              const bDefField = (isNaN(b.attributes[sortField])) ? b.attributes[sortField].toUpperCase().trim() : b.attributes[sortField];

              return (aDefField < bDefField) ? (sortDesc ? 1 : -1) : (sortDesc ? -1 : 1);
          }
          catch (err)
          {
            return 1;
          }
      }
        return 0
      }).map((item, i) => {
        return {
            id: i,
            content: (
              <IncidentListItem
                incident={item}
                isChecked={this.isSelected(item)}
                onMouseEnter={this.handleOnMouseOverIncident.bind(this)}
                onMouseExit={this.handleOnMouseOutIncident.bind(this)}
                onClicked={this.incidentClicked.bind(this)}
                onChecked={this.incidentChecked.bind(this)} />
            )
          }
      });
    }

    this.setState({
      sortedIncidents: incidents
    });
  }

  render() {

    const certifyDisabled = this.getIsCertifyDisabled();

    let clearSelectionPanel;
    if (this.props.incidentList.selectedIncidents.length > 0) {
      const selectedCount = this.props.incidentList.selectedIncidents.length;
      clearSelectionPanel = (
        <div className="clear-selection-container">
          <span>
            {selectedCount} incident{selectedCount > 1 ? "s" : ""} selected
          </span>
          <FlatButton
            style={{marginLeft: "10px"}}
            secondary={true}
            label="Clear Selection"
            onClick={this.clearSelectedIncidents} />
        </div>
      )
    }

    const downloadButton = this.state.isDownloading ? (
        <CircularProgress size={24} thickness={2} color={theme.palette.primary1Color} />
    ) : (
      <Button className="dummyButton" style={{textTransform: "none"}} aria-label="Download"
            onClick={this.handleDownloadCSV}
            color="primary"
            startIcon={<DownloadIcon style={{marginLeft: "0px !important", marginRight: "0px !important"}} />}>
            Download
          </Button>
    );

    const bulkEditButton = this.props.auth.isAdmin ?  (
      <Button className="dummyButton" style={{textTransform: "none"}} aria-label="Bulk Edit"
          onClick={this.handleBulkEdit}
          color="primary"
          disabled={!this.props.incidents || this.props.incidents.length === 0} 
          startIcon={<DownloadIcon style={{marginLeft: "0px !important", marginRight: "0px !important"}} />}>
          Bulk Edit
        </Button>
    ) : "";

    const certifyButton = this.props.auth.isCertifier ? (

      <Button className="dummyButton" style={{textTransform: "none"}} disabled={certifyDisabled} aria-label="Certify"
              onClick={this.bulkCertifyIncidents} 
              color="primary"
              startIcon={<VerifiedIcon size="medium" style={{marginLeft: "0px !important", marginRight: "0px !important"}}/>}>
            Certify {(this.props && this.props.incidentList &&
          this.props.incidentList.selectedIncidents &&
          this.props.incidentList.selectedIncidents.length > 1 ? " All" : "")}
       </Button>
    ) : "";

    let contents = (
      <div className="incidentList-panel">
        <div className="incident-list-header-panel">
          <div className="incident-list-sort-panel">
          <div
            className="results-list-collapser"
            onClick={this.props.toggleIncidentListCollapse}>
            <IconButton
              style={collapseBtnIconStyle}
              tooltip={this.props.incidentListVisible ? "Hide" : "Show"}
              tooltipPosition="top-center">
              <ArrowLeft className="results-list-collapser-icon" />
            </IconButton>
            <span className="results-list-collapser-text"></span>
          </div>
            <label className="incident-list-header-panel-content">Sort by:</label>
            <SelectField
              className="incident-list-header-panel-content"
              value={this.props.sortField}
              onChange={this.sortChange}
              autoWidth={true} >
              <MenuItem value="FireDiscoveryDateTime" primaryText="Discovery Date" />
              <MenuItem value="FireOutDateTime" primaryText="Fire Out Date" />
              <MenuItem value="IncidentTypeCategory" primaryText="Incident Category" />
              <MenuItem value="IncidentName" primaryText="Incident Name" />
              <MenuItem value="ModifiedOnDateTime" primaryText="Last Updated" />
              <MenuItem value="IncidentSize" primaryText="Incident Size" />
              <MenuItem value="MinUniqueness" primaryText="Uniqueness" />
              <MenuItem value="SelectedIncidents" primaryText="Selected Incidents" disabled={!(this.props && this.props.incidentList &&
                this.props.incidentList.selectedIncidents &&
                this.props.incidentList.selectedIncidents.length > 1)} />
            </SelectField>
            <IconButton
              onClick={this.sortDescChange}
              className={(this.props.sortDesc ? "sort-icon-desc incident-list-header-panel-content" : "sort-icon-asc incident-list-header-panel-content")}
              tooltip={this.props.sortDesc ? "Toggle Sort Ascending" : "Toggle Sort Descending" } >
              <SortIcon />
            </IconButton>
          </div>
          <IconButton
            className="share-incidents-button incident-list-header-panel-content"
            onClick={this.showShareDialog}
            tooltip="Share Incidents"
          >
            <ShareIcon />
          </IconButton>
          <ShareDialog
            url={this.props.shareURL}
            open={this.state.showShareDialog}
            onRequestClose={this.hideShareDialog}
            />
             <BulkEditDialog
              open={this.state.showBulkEditDialog}
              onClose={this.hideBulkEditDialog}
              incidents={this.props.incidentList.incidents}
            />
            
        </div>
        <div className="incident-list-action-panel">
        <Stack direction="row" spacing={1}>
          {bulkEditButton}
          {certifyButton}
          {downloadButton}
          <Button className="dummyButton" style={{textTransform: "none"}} aria-label="Upload" 
          onClick={this.handleUploadCSV}
          color="primary"
          disabled={this.props.auth.isReadOnly}
          startIcon={<UploadIcon style={{marginLeft: "0px !important", marginRight: "0px !important"}}/>}>
            Upload
          </Button>

          <Button className="dummyButton" style={{textTransform: "none"}} aria-label="Summaries"
            onClick={this.handleSummariesReporting}
            color="primary"
            disabled={!this.props.incidents || this.props.incidents.length === 0} 
            startIcon={<AssessmentIcon style={{marginLeft: "0px !important", marginRight: "0px !important"}}/>}>
            Summaries
          </Button>
        </Stack>
        </div>
        <div className="incident-list">
          <ReactScrollableList
            listItems={this.state.sortedIncidents}
            maxItemsToRender={15}
            heightOfItem={105} />
        </div>
        {clearSelectionPanel}
        <CertifyDialog
         open={this.state.showCertifyAgreement}
         onCertifyIncidentCancel={this.onCertifyIncidentCancel}
         onCertifyIncident={this.onBulkCertifyAgreed}
         />
         <StateUploadDialog
          open={this.state.showBulkUploadDialog}
          onCancelStateUpload={this.onCancelStateUpload}
          onBulkUploadIncidents={this.onBulkUploadIncidents}
          fieldInfos={this.props.appConfig.fieldInfos}
          />
          <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              open={this.state.showDownloadWarning}
              autoHideDuration={4000}
              onClose={this.handleWarningClose}
              action={
                <React.Fragment>
                  <IconButton size="small" aria-label="close" color="inherit" style={snackBtnIconStyle} onClick={this.handleWarningClose}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </React.Fragment>
              }
            />
      </div>
    );

    return ( contents )
  }
}

const mapStateToProps = state => ({
  // map: state.map,
  auth: state.auth,
  appConfig: state.config,
  incidentList: state.incidentList,
  filter: state.filter
  // router: state.router
});

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...authOperations,
    ...configOperations,
    ...incidentsOperations,
    ...filterOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(IncidentList)
